import { useId } from 'react';

import { cn } from '@/lib/utils';

interface KinoraMarkProps {
  size?: number;
  glow?: boolean;
  className?: string;
}

export function KinoraMark({ size = 28, glow = false, className }: KinoraMarkProps) {
  const id = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      aria-hidden="true"
      className={cn('shrink-0', className)}
    >
      <defs>
        <linearGradient id={`${id}-g`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="oklch(0.86 0.10 265)" />
          <stop offset="100%" stopColor="oklch(0.72 0.14 285)" />
        </linearGradient>
        {glow && (
          <filter id={`${id}-glow`} x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="4" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        )}
      </defs>
      <circle
        cx="50"
        cy="50"
        r="42"
        fill="none"
        stroke="var(--color-primary)"
        strokeOpacity="0.25"
        strokeWidth="3"
      />
      <path
        d="M 50 50 L 50 8 A 42 42 0 0 1 86.37 71 Z"
        fill={`url(#${id}-g)`}
        filter={glow ? `url(#${id}-glow)` : undefined}
        strokeLinejoin="round"
      />
      <circle cx="50" cy="50" r="3.5" fill="var(--color-background)" />
    </svg>
  );
}
